import { ApiConfig } from "../apiConfig/apiConfig";
import { ApiCallGet, ApiCallPost, ApiCallPatch } from "../apiConfig/apiCall";

/**
 * KYC VARA onboarding API (`/v1/user/kyc-vara/*`).
 * Every call resolves to the response body, also on errors: `{ success: false, code, message }`.
 */
const applicationsUrl = (path = "") => `${ApiConfig.baseKycVara}applications${path}`;

const KycVaraService = {
  /** Latest application of the logged-in user, or `data: null`. */
  getCurrentApplication: () => ApiCallGet(applicationsUrl("/current")),

  /** Body: `{ account_type: "INDIVIDUAL" | "CORPORATE" }`. 409 ACTIVE_APPLICATION_EXISTS when one is open. */
  createApplication: (accountType) => ApiCallPost(applicationsUrl(), { account_type: accountType }),

  /** Body: any of `account_type`, `income_gte_700k`, `assets_gte_3_5m`, `business_type`. */
  saveAnswers: (applicationId, answers) => ApiCallPatch(applicationsUrl(`/${applicationId}/answers`), answers),

  /** Server-side classification from the saved answers. */
  classify: (applicationId) => ApiCallPost(applicationsUrl(`/${applicationId}/classify`), {}),

  /** Creates (or resumes) the Didit session. Returns the application with `verification_url`. */
  startVerification: (applicationId) => ApiCallPost(applicationsUrl(`/${applicationId}/start-verification`), {}),
};

export default KycVaraService;
